<template>
  <div class="d-flex flex-column">
    <h1 class="h1">Simulateur de facturation BDW</h1>
    <div class="d-flex flex-row justify-content-around">
      <!-- Grille tarifaire du chiffre d'affaire -->
      <section>
        <table class="table table-hover table-bordered table-sm">
          <thead>
            <tr>
              <th colspan="2" class="p-3">Chiffre d'affaire (en € HT)</th>
              <th class="p-3">Forfait (en € HT) / an</th>
              <th class="m-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in itemsCa" :key="index">
              <td class="text-center">{{nbrLinter(item.minValue)}}</td>
              <td class="text-center">{{nbrLinter(item.maxValue)}}</td>
              <td class="nopadding text-center">{{nbrLinter(item.price)}}</td>
              <td class="delete">
                <button type="button" class="btn btn-danger" v-on:click="removeRange(itemsCa, index)">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </button>
              </td>
            </tr>
            <!-- Nouvelle tranche à ajouter -->
            <tr>
              <td>
                <input type="number" class="form-control nopadding text-center" :placeholder="0" v-model="newRangeCa.minValue" />
              </td>
              <td>
                <input type="number" class="form-control nopadding text-center" :placeholder="0" v-model="newRangeCa.maxValue" />
              </td>
              <td>
                <input type="number" class="form-control nopadding text-center" :placeholder="0" v-model="newRangeCa.price" />
              </td>
              <td>
                <button class="btn btn-success w-100" v-on:click="addRangeCa()" id="show-modal">+</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <!-- Grille tarifaire du nombre d'articles' -->
      <section>
        <table class="table table-hover table-bordered table-sm">
          <thead>
            <tr>
              <th colspan="2" class="p-3">Nombre d'Articles</th>
              <th class="p-3">Supplément (en € HT) / an</th>
              <th class="m-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in itemsNbrArticles" :key="index">
              <td class="text-center">{{nbrLinter(item.minValue)}}</td>
              <td class="text-center">{{nbrLinter(item.maxValue)}}</td>
              <td class="text-center">{{nbrLinter(item.price)}}</td>
              <td class="delete">
                <button type="button" class="btn btn-danger" v-on:click="removeRange(itemsNbrArticles, index)">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </button>
              </td>
            </tr>
            <!-- Nouvelle tranche à ajouter -->
            <tr>
              <td>
                <input type="number" class="form-control nopadding text-center" :placeholder="0" v-model="newRangeNbrArticles.minValue" />
              </td>
              <td>
                <input type="number" class="form-control nopadding text-center" :placeholder="0" v-model="newRangeNbrArticles.maxValue" />
              </td>
              <td>
                <input class="form-control nopadding text-center" :placeholder="0" v-model="newRangeNbrArticles.price" />
              </td>
              <td>
                <button class="btn btn-success w-100" v-on:click="addRangeNbrArticles()" id="show-modal">+</button>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>

    <hr />

    <div class="totaux-container">
      <div class="items">
        <!--Bloc affichage tarif CA-->
        <div class="item">
          <h5>Tarif CA Total</h5>
          <p><strong>{{nbrLinter(totalCa)}} €</strong></p>
        </div>

        <!--Bloc affichage tarif articles-->
        <div class="item">
          <h5>Tarif Articles Total</h5>
          <p><strong>{{nbrLinter(totalArticles)}} €</strong></p>
        </div>

        <!--Bloc affichage tarif total-->
        <div class="item">
          <h5>Tarif Total</h5>
          <p><strong>{{nbrLinter(total)}} €</strong></p>
        </div>
      </div>
    </div>

    <hr />

    <section>
      <!-- Renseignements, selection de l'année et export Excel  -->
      <div class="d-flex justify-content-between">
        <h4 class="h4 py-4">{{counterList()}}</h4>
        <div class="w-25">
          <label>Année : </label>
          <select class="form-select" v-model="selectedPeriod" v-on:change="populateArrayFrsResults()" v-on:click="getValue($event)">
            <option v-for="(item, index) of dataPeriods" :value="item.annee" :key="index">{{item.annee}}</option>
          </select>
        </div>
        <button class="btn btn-success my-4" v-on:click="generateExcel()">Exporter</button>
      </div>

      <!-- Tableau exportable -->
      <table class="table table-striped table-hover table-bordered">
        <thead>
          <tr>
            <th class="p-4">ID Compta</th>
            <th class="p-4">Nom Frs</th>
            <th class="p-4">Famille</th>
            <th class="p-4">CA</th>
            <th class="p-4">Tarif CA</th>
            <th class="p-4">Nbre Articles</th>
            <th class="p-4">Tarif Articles</th>
            <th class="p-4">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in getAllDatas" :key="index">
            <td class="p-4">{{item.IdCompta}}</td>
            <td class="p-4">{{item.Name}}</td>
            <td class="p-4">{{item.N1}}</td>
            <td class="p-4">{{nbrLinter(item.ChiffreAffaire)}} €</td>
            <td class="p-4"><strong>{{nbrLinter(item.tarifCa)}} €</strong></td>
            <td class="p-4">{{nbrLinter(item.NbArticle)}}</td>
            <td class="p-4"><strong>{{nbrLinter(item.tarifArticles)}} €</strong></td>
            <td class="p-4"><strong>{{nbrLinter(item.total)}} €</strong></td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
  import { monitoringFrs } from '@/utils/bdoublewin';
  import { getCaRfaBySuppliers, getFrsListAdminAll } from '@/utils/frs';
  import { exportExcel } from '@/utils/exportExcel';
  import { getAllPeriods } from '@/utils/period';

  export default {
    name: "SimulationFacturation",
    props: [],
    data() {
      return {
        // Ajout nouvelle tranche
        newRangeCa: {
          minValue: 0,
          maxValue: 0,
          price: 0
        },
        newRangeNbrArticles: {
          minValue: 0,
          maxValue: 0,
          price: 0
        },

        // Injecte la donnée initiale de la grille tarifaire
        itemsCa: [],
        itemsNbrArticles: [],

        // Pour stocké les données renvoyées (tableau)
        dataFrsCa: [],
        dataFrsNbreArticles: [],

        // Totaux
        totalCa: 0,
        totalArticles: 0,
        total: 0,

        // Pour la periode / année
        dataPeriods: [],
        periode: 0,
        selectedPeriod: 0,
      }
    },
    mounted() {
      this.populatePeriods();
      this.populateArrayCa();
      this.populateArrayNbrArticles();
      this.populateArrayFrsResults();
    },
    computed: {
      // Récupère toutes les infos à transmettre.
      getAllDatas() {
        // Mise à 0 des totaux
        this.totalCa = 0;
        this.totalArticles = 0;
        this.total = 0;

        // Ajoute les colonnes (tarifCa, tarifArticles, total) dans le tableau à rendre 
        let res = this.dataFrsCa.map((r) => {

          // Ajoute les colonnes dans la donnée initiale
          r.tarifCa = this.tarifCaCalculator(r.ChiffreAffaire);
          r.tarifArticles = this.tarifNbrArticlesCalculator(r.NbArticle);
          r.total = this.tarifCaCalculator(r.ChiffreAffaire) + this.tarifNbrArticlesCalculator(r.NbArticle);

          // Somme des tarifs
          this.totalCa += r.tarifCa;
          this.totalArticles += r.tarifArticles;
          this.total = this.totalCa + this.totalArticles;

          return r;
        });
        return res;
      },
    },
    methods: {
      // Gère le changement de periode / année
      getValue(e) {
        // Récupère l'année souhaitée
        let year = e.target.value;
        
        // Renvoyer la periode associée
        let getItem = this.dataPeriods.find(e => e.annee == year);
        this.periode = getItem.periodId;
      },

      // Ajoute une nouvelle tranche dans le tableau du Nbre d'articles.
      addRangeNbrArticles() {
        let minElmnt = this.itemsNbrArticles[0];

        // Vérifie la place de la nouvelle tranche avant de la push
        if ((parseInt(this.newRangeNbrArticles.maxValue) > minElmnt.minValue) && (parseInt(this.newRangeNbrArticles.maxValue) < minElmnt.maxValue)) {
          minElmnt.minValue = this.newRangeNbrArticles.maxValue;
        };

        // Push la tranche.
        this.itemsNbrArticles.push({
          minValue: this.newRangeNbrArticles.minValue,
          maxValue: this.newRangeNbrArticles.maxValue,
          price: parseInt(this.newRangeNbrArticles.price)
        });

        // Faire un trie DSC
        this.itemsNbrArticles.sort((a, b) => a.minValue - b.maxValue);

        // Refresh 
        this.populateArrayNbrArticles();

        // Création d'une nouvelle tranche vide
        this.newRangeNbrArticles = {
          minValue: 0,
          maxValue: 0,
          price: 0
        };
      },

      // Ajoute une nouvelle tranche dans le tableau des CA.
      addRangeCa() {
        let minElmnt = this.itemsCa[0];

        // Et vient modifier la minValue pour ne pas casser les tarifs
        if ((parseInt(this.newRangeCa.maxValue) > minElmnt.minValue) && (parseInt(this.newRangeCa.maxValue) < minElmnt.maxValue)) {
          minElmnt.minValue = this.newRangeCa.maxValue;
        };

        // Push la tranche.
        this.itemsCa.push({
          minValue: parseInt(this.newRangeCa.minValue),
          maxValue: parseInt(this.newRangeCa.maxValue),
          price: parseInt(this.newRangeCa.price)
        });

        // Faire un trie DSC
        this.itemsCa.sort((a, b) => a.minValue - b.maxValue);

        // Réinjecte la donnée dans la page
        this.populateArrayCa();

        // Création d'une nouvelle tranche vide
        this.newRangeCa = {
          minValue: 0,
          maxValue: 0,
          price: 0
        };
      },

      // Pour supprimer une tranche.
      removeRange(arr, index) {
        if (window.confirm("Confirmer la suppression ?")) {
          arr.splice(index, 1);
        };
      },

      // Renseigne les infos du tableau CA.
      populateArrayCa() {
        // Au chargement de la page, on injecte les valeurs initiales
        if (this.itemsCa.length == 0) {
          // Data originale
          this.itemsCa.push(
            {
              minValue: 0,
              maxValue: 500000,
              price: 500
            },
            {
              minValue: 500000,
              maxValue: 1000000,
              price: 750
            },
            {
              minValue: 1000000,
              maxValue: 1100000,
              price: 1000
            },
            {
              minValue: 1100000,
              maxValue: 1200000,
              price: 1100
            },
            {
              minValue: 1200000,
              maxValue: 1300000,
              price: 1200
            },
            {
              minValue: 1300000,
              maxValue: 1400000,
              price: 1300
            },
            {
              minValue: 1400000,
              maxValue: 1500000,
              price: 1400
            },
            {
              minValue: 1500000,
              maxValue: 1600000,
              price: 1500
            },
          );
        };
      },

      // Renseigne les informations du tableau Nbre articles.
      populateArrayNbrArticles() {
        // Au chargement de la page, on injecte les valeurs initiales
        if (this.itemsNbrArticles.length == 0) {
          // Data originale
          this.itemsNbrArticles.push(
            {
              minValue: 0,
              maxValue: 2000,
              price: 0
            },
            {
              minValue: 2000,
              maxValue: 5000,
              price: 150
            },
            {
              minValue: 5000,
              maxValue: 10000,
              price: 250
            },
            {
              minValue: 10000,
              maxValue: 20000,
              price: 350
            },
            {
              minValue: 20000,
              maxValue: 30000,
              price: 500
            },
          );
        };
      },

      // Renseigne les informations des frs.
      populateArrayFrsResults() {
        monitoringFrs().then(frsBdw => {
          getFrsListAdminAll().then(frsSdc => {
            let mergedFrsList = frsSdc.map(_frsSdc => {
              let frsMerged = _frsSdc;
              if (frsMerged["ChiffreAffaire"] == undefined) {
                frsMerged["ChiffreAffaire"] = 0;
              }
              frsMerged["ChiffreAffaire"] = 0;

              // Nombre articles
              const _frsInBdw = frsBdw.find(e => e.SupplierCode == _frsSdc.CodeIntranet);

              // FRS existe dans BDW
              if (_frsInBdw != undefined) {
                frsMerged["NbArticle"] = _frsInBdw.NbProd;

                // Chiffre d'affaires
                let guidsList = [];
                guidsList.push(_frsSdc.Guid);
                getCaRfaBySuppliers(guidsList, [this.periode], 1, 2).then(result => {
                  if (result.length > 0) {
                    if (result[0].hasOwnProperty("Ca")) {
                      frsMerged["ChiffreAffaire"] = result[0].Ca;
                    } else {
                      frsMerged["ChiffreAffaire"] = 0;
                    };
                  } else {
                    frsMerged["ChiffreAffaire"] = 0;
                  };
                });
              };
              return frsMerged;
            });
            this.dataFrsCa = mergedFrsList.filter(e => e.hasOwnProperty("NbArticle"));
          });
        });
      },

      // Parcours les tranches de prix CA et renvoie la valeur associée.
      // ca = chiffre d'affaire du frs
      tarifCaCalculator(ca) {
        // Initialise le tarif à 0
        let res = 0;
        this.itemsCa.forEach((r) => {
          if (ca >= r.minValue && ca <= r.maxValue) {
            res = r.price;
          } else if (ca > r.maxValue) {
            res = this.itemsCa.at(-1).price;
          }
        });
        return res;
      },

      // Parcours les tranches de prix NbrArticles et renvoie la valeur associée.
      tarifNbrArticlesCalculator(nbreArticles) {
        let res = 0;
        this.itemsNbrArticles.forEach((r) => {
          if (nbreArticles > r.minValue && nbreArticles < r.maxValue) {
            res = r.price;
          } else if (nbreArticles > r.maxValue) {
            res = this.itemsNbrArticles.at(-1).price;
          }
        });
        return res;
      },

      // Renvoie le nombre de frs. 
      counterList() {
        if (this.dataFrsCa.length > 1) {
          return this.dataFrsCa.length + " résultats trouvés.";
        } else {
          return this.dataFrsCa.length + " résultat trouvé.";
        }
      },

      // Mise en forme des nombres
      nbrLinter(nbr) {
        return new Intl.NumberFormat().format(nbr);
      },

      // Génération d'un excel
      generateExcel() {
        // On crée le fichier Excel
        let cols = Object.keys(this.dataFrsCa[0]).map(m => {
          return {
            label: m,
            field: m
          }
        });
        // Export
        exportExcel(cols, this.dataFrsCa, "Simulation_Facturation");
      },

      // Récupérer les périodes associées aux années
      populatePeriods() {
        // Parcours la liste
        getAllPeriods().then((r) => {
          // Insère les valeurs par défaut (dernière année en cours) à la volé
          this.selectedPeriod = r[0].annee;
          this.periode = r[0].periodId;
          r.forEach((_r) => {
            // Rempli le tableau
            this.dataPeriods.push(_r);
          });
        });
      },
    }
  }
</script>

<style scoped>
  .delete{
    text-align: center;
  }

  .totaux-container {
    width: 100%;
  }

  .items {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  .item {
    display: flex;
    flex-direction: column;
    padding: 1em;
    text-align: center;
  }

  .item p {
    font-size: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/SimulationFacturation.vue